import BasicInitializationService from "../../services/initialization/basicInitializationService";
import makeWidgetFor from "../../viewModels/makeWidgetFor";
import { registerWidget } from "../widget";
import RoadMapViewModel from "../../viewModels/tradingPlaces/roadMapViewModel";

const TollRoadsWidgetIdentifier = "edaz-toll-roads";

registerWidget({
  component: makeWidgetFor(TollRoadsWidgetIdentifier, [RoadMapViewModel], BasicInitializationService),
  configuration: {
    tagname: TollRoadsWidgetIdentifier,
  },
});
